import { render, staticRenderFns } from "./left_blue.vue?vue&type=template&id=1912957f&scoped=true"
import script from "./left_blue.vue?vue&type=script&lang=js"
export * from "./left_blue.vue?vue&type=script&lang=js"
import style0 from "./left_blue.vue?vue&type=style&index=0&id=1912957f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1912957f",
  null
  
)

export default component.exports